<div class="container">
  <div class="container-content">
   <div>
      <img
        class="logo"
        src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
      />
      <div
        class="landing-page-description"
        [innerHTML]="messageTitle | safeHtml"
      ></div>
      <ng-container *ngIf=isLoading matSuffix>
      <mat-spinner diameter="25"></mat-spinner>
      </ng-container>
      <div *ngIf="!isLoading && !origemComercialId" class="input-dropdown-component">
        <ng-select
          #ngSelect
          required
          [readonly]="readOnly"
          [searchable]="false"
          [formControl]="currentFormControl"
          [clearable]="false"
          [virtualScroll]="true"
          placeholder="Selecione uma opção"
          [notFoundText]="(buscarLojasPorProximidade.raioMetros && buscarLojasPorProximidade.raioMetros > 0) ? 'Nenhuma loja encontrada nas proximidades' : 'Nenhuma opção encontrada'"

        >
          <ng-option *ngFor="let option of options" [value]="option.valor">{{
            buscarLojasPorProximidade.raioMetros && buscarLojasPorProximidade.raioMetros > 0 ? option.titulo + ' (' + (option.distanciaEmMetros ? (option.distanciaEmMetros/1000).toFixed(2) : 0) + "km)":
            option.titulo
          }}</ng-option> 
        </ng-select>
      </div>
      <!-- <div class="cf-turnstile" data-sitekey="0x4AAAAAAA_pvk9uxbCGcyX0"></div> !-->
      <app-rounded-button [class.hide]="!isValid()" class="landing-page-button" (click)="startForm()">
        Vamos começar
      </app-rounded-button>
   </div>
  </div>
  <div class="img-entrada"></div>
</div>
